<!--
	TreeViewerNode.svelte
-->

<script>
    import NodeIndenter from './NodeIndenter.svelte';

    // SMUI components
    import { Icon } from '@smui/icon-button';
    import { mdiPlay, mdiCheckboxBlankOutline, mdiCheckboxMarked } from '@mdi/js';
    import { Svg } from '@smui/common/elements';

    export let level;
    export let node;
    export let onNodeClick;

    const toggleIsClosed = () => {
        node.isClosed = !node.isClosed;
    }

    // tree is updated locally via $: selectedCss
    // eventually calls store's updateSelectedNodesPool
    const toggleIsSelected = () => {
        node.isSelected = !node.isSelected;     // TODO: do not use <Checkbox>
        onNodeClick(node);                      // passed in from <SearchPanels>
    }

    $: selectedCss = node.isSelected ? "selected " : "";
    $: selectedStyle = node.isSelected ? "color: " + node.color : "";
    $: closedCss = node.isClosed ? "closed " : "";

</script>

<style>

    .flex-center {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .node-row {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .node-without-children {
        margin: 4px 0px;
        user-select: none;
        color: var(--tcare-primary);
        font-size: .9em;
        /* transition: all .5s; */
        /* height: 0px; */
    }

    .closed {
        margin: 0px 0px;
        height: 0px;
    }

    .node-without-children.closed {
        margin: 0px 0px;
        height: 0px;
    }

    /* contains the nodes under a category */
    .child-nodes {
        overflow: hidden;
        transition: all .5s;
    }

    .node-with-children {
        user-select: none;
        color: var(--tcare-primary);
        font-size: 1em;
        font-weight: bold;
    }
    .selected {
        font-weight: 600;
        /* color: var(--tcare-selected); */
    }

    .node-with-children span {
        margin-left: 10px;
        font-size: .9em;
        font-weight: normal;
    }

    .node-icon {
        width: 24px;
        height: 24px;
        margin-right: 4px;
        /* transition: all .5s; */
    }
    :global(.node-icon svg) {
        outline: none;
    }

    .icon-closed {
        transform: rotate(0deg);
    }
    .icon-open {
        transform: rotate(90deg);
    }

</style>

<!-- RECURSIVE :-) <svelte:self nodes={node.children} /> -->

{#if node.children}
    <div class={"node-with-children node-row " + selectedCss} on:click={toggleIsClosed}>
        <NodeIndenter {level}/>
        {#if node.isClosed}
            <div class="node-icon flex-center icon-closed">
                <Icon component={Svg} viewBox="0 0 24 24"><path d={mdiPlay} /></Icon>
            </div>
        {:else}
            <div class="node-icon flex-center icon-open">
                <Icon component={Svg} viewBox="0 0 24 24"><path d={mdiPlay} /></Icon>
            </div>
        {/if}
        {node.label} <span>({node.children.length})</span>
    </div>
    <div class={"child-nodes " + closedCss}>
        {#each node.children as node}
            <svelte:self level={level+1} {node} {onNodeClick} />
        {/each}
    </div>
{:else}
    <div class={"node-without-children node-row " + selectedCss} 
        on:click={toggleIsSelected}
        style={selectedStyle}
    >
        <NodeIndenter {level}/>
        <div class="node-icon flex-center">
            <Icon component={Svg} viewBox="0 0 24 24">
                {#if node.isSelected}
                    <path d={mdiCheckboxMarked} fill={node.color}/>
                {:else}
                    <path d={mdiCheckboxBlankOutline} />
                {/if}
            </Icon>
        </div>
        {node.label}
    </div>
{/if}
